import * as React from "react";
import {Card, Modal} from "semantic-ui-react";
import {compose, Dispatch} from "redux";
import {translate} from "react-i18next";
import {OptionPreviousApprovalHistoryDto, WorkflowOptionApprovalDto} from "../../../services/Client";
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";
import Button from "../../../components/Button";
import {connect} from "react-redux";
import {IReduxState} from "../../../redux/IReduxState";
import ApprovalViewActions from "../../../redux/actions/ApprovalViewActions";
import TextPartitionContainer from "../TextPartitionContainer";
import ModeltypesLine from "../ModeltypesLine";
import CardGroup from "semantic-ui-react/dist/commonjs/views/Card/CardGroup";
import {formatDate} from "../../../components/Table/dataHandler/Utils";

interface IMapDispatchToProps {
    getLastApprovalOptionHistory: (
        approval: WorkflowOptionApprovalDto,
        setMessage: (message: string) => void,
        setResult: (previousApproval: OptionPreviousApprovalHistoryDto) => void
    ) => void;
}

interface ILastApprovalComparingPropsProps {
    approval: WorkflowOptionApprovalDto;
    userLanguage: string;
}

interface ILastApprovalComparingProps extends ILastApprovalComparingPropsProps, ITranslatedComponent, IMapDispatchToProps { }

interface ILasstApprovalComparingState {
    previousApproval?: OptionPreviousApprovalHistoryDto;
    isOpen: boolean;
    message: string;
}

class LastApprovalComparing extends React.Component<ILastApprovalComparingProps, ILasstApprovalComparingState> {

    constructor(props: ILastApprovalComparingProps) {
        super(props);

        this.state = {
            previousApproval: undefined,
            isOpen: false,
            message: "",
        };
    }

    private setMessage = (message: string) => {
        this.setState({message});
    }

    private setResult = (result: OptionPreviousApprovalHistoryDto) => {
        this.setState({previousApproval: result});
    }

    private onClose = () => {
        this.setState({
            previousApproval: undefined,
            isOpen: false,
            message: "",
        });
    }

    private onModalOpen = () => {
        this.setState({
            isOpen: true,
        });

        this.props.getLastApprovalOptionHistory(this.props.approval, this.setMessage, this.setResult);
    }
    private renderRightSectionOfApproval=(prevApprovalMeesage:string,previousApproval:any,approval:any)=> {
      
        if(approval && previousApproval && approval.parentApprovedTimestamp === 0 && previousApproval.changedTimestamp ===0 ) {
            return (
                <span style={{fontWeight: "bold",}}>{this.props.t("APPROVAL_VIEW:APPROVAL_HISTORY_NOT_FOUND")}</span>
            );
        }
        return (
          <>
            <Card.Header>
              {`${prevApprovalMeesage}`}{" "}
              {approval.parentApprovedTimestamp === 0 &&
                `${
                  (previousApproval && previousApproval.changedTimestamp) && formatDate(previousApproval.changedTimestamp)
                }`}
            </Card.Header>
            {approval.parentApprovedTimestamp === 0 && (
              <TextPartitionContainer
                fluid={true}
                partitions={(previousApproval && previousApproval.texts) || []}
              />
            )}
            {approval.parentApprovedTimestamp > 0 && (
              <TextPartitionContainer
                fluid={true}
                partitions={(approval && approval.parentTexts) || []}
              />
            )}
            {((previousApproval && previousApproval.texts.length > 0) || (approval && approval.parentTexts)) && (
              <ModeltypesLine
                fluid={true}
                assignedModeltypes={
                  previousApproval && previousApproval.assignments
                }
                userLanguage={this.props.userLanguage}
              />
            )}
          </>
        );
    }
    render() {
        const {t, approval} = this.props;
        const {previousApproval} = this.state;
        let prevApprovalMeesage = t("APPROVAL_VIEW:PREVIOUS_APPROVAL_REQUEST");
        if(approval.parentApprovedTimestamp > 0) {
            prevApprovalMeesage=`${t('APPROVAL_VIEW:PREVIOUS_APPROVAL_REQUEST')} ${approval.parentModelyear} ${formatDate(approval.parentApprovedTimestamp)}`;
        }
        let rejectionReason = approval.prevRejectMessage;
        if(approval.parentApprovedTimestamp > 0) {
            prevApprovalMeesage=`${t('APPROVAL_VIEW:PREVIOUS_APPROVAL_REQUEST_MODEL_YEAR')} ${approval.parentModelyear} ${formatDate(approval.parentApprovedTimestamp)}`;
        } else {
            if(previousApproval && previousApproval.lastWorkflowStep && previousApproval.rejectedBefore) {
                prevApprovalMeesage= t("APPROVAL_VIEW:LAST_APPROVAL_REQUEST");
            }
            if(previousApproval && previousApproval.resetBefore && previousApproval.lastWorkflowStep) {
                prevApprovalMeesage= t("APPROVAL_VIEW:LAST_APPROVAL_REQUEST");
            }
        }
        
        if(previousApproval && previousApproval.resetBefore) {
            rejectionReason=t("APPROVAL_VIEW:OPTION_RESETED");
        }
       
        return !this.state.isOpen
            ?
            (
                <Button
                    icon="history"
                    label={t("APPROVAL_VIEW:SHOW_HISTORY_DETAIL")}
                    labelPosition="after"
                    onClick={this.onModalOpen}
                    disabled={approval.firstApproval}
                />
            )
            :
            (
                <Modal
                    closeIcon={true}
                    className="history-dialog-container"
                    open={this.state.isOpen}
                    size={"fullscreen"}
                    onClose={this.onClose}
                >
                    <Modal.Header>{`${t("HISTORY:APPROVAL_HISTORY_TITLE")} ${approval.optionCode}`}</Modal.Header>
                    <Modal.Content>
                        <div className="history-container">
                            <p
                                style={{
                                    fontSize: 16,
                                }}
                            >
                                <span style={{fontWeight: "bold",}}>{t("APPROVAL_VIEW:REJECT_REASON")}</span>
                                {rejectionReason}
                            </p>
                            <CardGroup centered={true} itemsPerRow={2}>
                                <Card fluid={true}>
                                    <Card.Content>
                                        <Card.Header>{t("APPROVAL_VIEW:ACTUAL_APPROVAL_REQUEST")}</Card.Header>
                                        <TextPartitionContainer
                                            fluid={true}
                                            partitions={approval.basicTexts || []}
                                            prevPartitions={(this.state.previousApproval && this.state.previousApproval.texts) || []}
                                        />
                                        <ModeltypesLine
                                            fluid={true}
                                            assignedModeltypes={approval.assignedModeltypes}
                                            previousAssignedModeltypes={this.state.previousApproval && this.state.previousApproval.assignments}
                                            userLanguage={this.props.userLanguage}
                                        />
                                    </Card.Content>
                                </Card>
                                <Card fluid={true}>
                                    <Card.Content fluid={true}>
                                        {this.renderRightSectionOfApproval(prevApprovalMeesage,this.state.previousApproval,approval)}
                                    </Card.Content>
                                </Card>
                            </CardGroup>
                        </div>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            icon={"ban"}
                            onClick={this.onClose}
                        />
                    </Modal.Actions>
                </Modal>
            );
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: ILastApprovalComparingProps): IMapDispatchToProps => {
    return {
        getLastApprovalOptionHistory: (approval, setMessage, setResult) =>
            dispatch(ApprovalViewActions.GetLastApprovalOptionHistory(ownProps.t, approval, setMessage, setResult)),
    };
};

export default compose<React.ComponentType<ILastApprovalComparingPropsProps>>(
    translate(["OPTIONS_VIEW", "GLOBAL", "WORKFLOW", "BASEOPTIONS", "HISTORY"]),
    connect<{}, IMapDispatchToProps>(undefined, mapDispatchToProps),
)(LastApprovalComparing);



// WEBPACK FOOTER //
// ./src/views/ApprovalView/LastApprovalComparing/LastApprovalComparing.tsx